
import stringComparison from 'string-comparison'
import {getCoefficient} from 'ochiai-string-similarity'
import trigramSimilarity from 'trigram-similarity'
import { compareTwoTexts } from 'text-sound-similarity';
import { toGreeklish,removeStopWords } from 'greek-utils';
import  {lig2,lig3} from 'talisman/metrics/lig';
import { similarity as lenght } from 'talisman/metrics/length';
import jaro from 'talisman/metrics/jaro';
import {similarity as ratOber} from 'talisman/metrics/ratcliff-obershelp';
import tversky from 'talisman/metrics/tversky';
import {getSimilarity} from 'calculate-string-similarity';

function getUniqueWords(str) {
  const wordsArray = str.split(/\s+/);
  const uniqueWords = new Set(wordsArray);
  return uniqueWords;
}







const ProcLibraryAns = ({st1,st2}) => {

  
  st1=removeStopWords(st1)
  st2=removeStopWords(st2)
  st1=toGreeklish(st1)
  st2=toGreeklish(st2)

 let  set1=getUniqueWords(st1);
 let set2=getUniqueWords(st2);
  st1=[...set1].join(' ');
  st2=[...set2].join(' ');
 
  
console.log('st1',st1);
console.log('st2',st2);
 let lev=stringComparison.levenshtein
  lev=lev.similarity(st1, st2);
  console.log('lev:',lev);
 let lcsc=stringComparison.longestCommonSubsequence
  lcsc=lcsc.similarity(st1, st2);
  console.log('lcsc:', lcsc);
 let jw=stringComparison.jaroWinkler;
  jw=jw.similarity(st1, st2);
  console.log('jw:',jw);
 let mlcsc=stringComparison.mlcs
  mlcsc=mlcsc.similarity(st1, st2);
  console.log('mlcsc:', mlcsc);
 let jac=stringComparison.jaccardIndex


  jac=jac.similarity(st1, st2);
 console.log('jac:', jac);
 let cos=stringComparison.cosine
  cos=cos.similarity(st1, st2);
  console.log('cos:', cos);
 let dic=stringComparison.diceCoefficient
  dic=dic.similarity(st1, st2);
  console.log('dic:', dic);

 
  


let trigsim=trigramSimilarity(st1,st2)
console.log('trigsim',trigsim);



let ochiai=getCoefficient(st1,st2)
console.log('ochiai',ochiai);
let soundScore=compareTwoTexts(st1,st2);
console.log('soundScore',soundScore);

let l2=lig2(st1,st2);
console.log('l2',l2);

let l3=lig3(st1,st2);
console.log('l3',l3);

let jrt=jaro(st1,st2);
console.log('jrt',jrt);

//let lnt=lenght(st1,st2);
//console.log('lnt',lnt);



let ro=ratOber(st1,st2);
console.log('ro',ro);
const parameters = {
 symmetric: false,
 alpha: 0.5,
  beta: 0.1
};

let tvsp=tversky.bind(null, parameters);
let tvs=tvsp(st1,st2);

console.log('tvs',tvs);


let sim=getSimilarity(st1,st2)/100;
console.log('calcsim ',sim);







let totalScore = (lev+lcsc+mlcsc+dic+trigsim+soundScore+l2+l3+ro+jrt+jac+tvs+sim+jw+cos+ochiai)/16;


console.log('totalScore',totalScore);


  return (
    totalScore
  )
}

export default ProcLibraryAns